var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"RestartButton",on:{"click":function($event){return _vm.restart()}}},[_vm._v(" "+_vm._s(_vm.$t('components.restart-button.restart'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }